import { BaseService, PagedResult } from './base/base.service';

export type FeedbackStatus = 'New' | 'InReview' | 'ActionPlanned' | 'Resolved' | 'Closed' | 'Rejected';

export interface FeedbackItem {
  id: string;
  userId: string;
  userName?: string;
  category: string;
  status: FeedbackStatus;
  message: string;
  rating?: number;
  sentiment?: string;
  contextType?: string;
  contextId?: string;
  response?: string;
  assignedTo?: string;
  tags?: string[];
  createdAt: string;
  updatedAt?: string;
  lastStatusChangeAt?: string;
}

export interface FeedbackFilters {
  status?: FeedbackStatus;
  category?: string;
  userId?: string;
  search?: string;
  sort?: 'newest' | 'oldest';
  skipCount?: number;
  maxResultCount?: number;
}

export interface UpdateFeedbackRequest {
  status?: FeedbackStatus;
  response?: string;
  assignedTo?: string;
  tags?: string[];
}

class FeedbackService extends BaseService {
  constructor() {
    super('/api/engagement');
  }

  async getList(params: FeedbackFilters): Promise<PagedResult<FeedbackItem>> {
    const query = new URLSearchParams();
    if (params.status) query.set('status', params.status);
    if (params.category) query.set('category', params.category);
    if (params.userId) query.set('userId', params.userId);
    if (params.search) query.set('search', params.search);
    if (params.sort) query.set('sort', params.sort);
    if (typeof params.skipCount === 'number') query.set('skipCount', String(params.skipCount));
    if (typeof params.maxResultCount === 'number') query.set('maxResultCount', String(params.maxResultCount));

    const qs = query.toString();
    return this.get<PagedResult<FeedbackItem>>(qs ? `/feedback?${qs}` : '/feedback');
  }

  async update(id: string, payload: UpdateFeedbackRequest): Promise<FeedbackItem> {
    return this.put<FeedbackItem, UpdateFeedbackRequest>(`/feedback/${id}`, payload);
  }
}

export const feedbackService = new FeedbackService();
